import { NestedGeneric } from './nested-generic';

class ActivityNode {
  address: string;
  deviceTime: Date;
}

export interface Activity{

  type: string;
  day: string;

  mobileId: string;
  deviceId: string;

  devicePropertyId: string;
  mobilePropertyId: string;

  firstNode: ActivityNode;
  lastNode?: ActivityNode;

  odometer: number;
  maxSpeed: number;
  alarmCount: number;
  positionCount: number;
  stopCount: number;
  mobile?: NestedGeneric
}
